export default {
	props: {
		label: {
			type: String
		},
		layout: {
			type: String,
			default: 'horizontal'
		},
		options: {
			type: Array,
			required: false,
			default: []
		},
		ajaxUrl: {
			type: [String, null],
			required: false,
			default: null
		}
	},
}